/**
 * The registrar's signing service as the signing pages need it: the service chosen
 * (`SignatureSettings.signer`), the daily batch time, and whether SmartCA is configured (an
 * enabled `VNPT_SMARTCA` version in the Control Center, or compliance-worker running on
 * `REGISTRAR_SMARTCA_*`). `configured` is null when it cannot be read (no `integration.read`).
 */

import { api } from '../api';
import type { SignatureSettings } from '../api/areas/postOperations';
import { hubUrl } from '../nav/hubs';
import { useApi } from './useApi';

export interface SigningService {
  signer: SignatureSettings['signer'] | null;
  dailyAt: string;
  configured: boolean | null;
}

/** "Cài đặt › Kết nối › SmartCA". */
export const SMARTCA_SETTINGS_URL = hubUrl('settings', 'connections', 'smartca');

export async function loadSigningService(signal?: AbortSignal): Promise<SigningService> {
  const b = await api.listSignatureBatches({ signal }).catch(() => null);
  const signer = b?.settings.signer ?? null;
  const configured =
    signer === 'SMARTCA'
      ? await api.getProviderSetting('VNPT_SMARTCA', { signal }).then(
          (d) => Boolean(d.active?.enabled) || d.applied_by.some((a) => a.service === 'compliance-worker' && a.source === 'ENVIRONMENT' && !a.last_error),
          () => null,
        )
      : null;
  return { signer, dailyAt: b?.settings.daily_at ?? '16:00', configured };
}

export function useSigningService(enabled = true) {
  return useApi((signal) => (enabled ? loadSigningService(signal) : Promise.resolve<SigningService>({ signer: null, dailyAt: '16:00', configured: null })), [enabled]);
}
